export default __webpack_public_path__ + "static/media/T3.98b70c4f.svg";